<template>
  <div class="space-y-3 rounded-md border border-gray-200 p-4">
    <div class="flex items-center justify-between">
      <h4 class="text-sm font-semibold text-gray-900">{{ title }}</h4>
      <button
        v-if="removable"
        type="button"
        class="text-xs text-red-600 hover:text-red-800"
        @click="$emit('remove')"
      >
        {{ $gettext("Retirer") }}
      </button>
    </div>
    <div class="grid grid-cols-2 gap-3">
      <CtifFieldRow v-model="model.last_name" :label="$gettext('Nom')" required />
      <CtifFieldRow v-model="model.first_name" :label="$gettext('Prénom')" required />
      <CtifFieldRow v-model="model.birth_date" :label="$gettext('Date de naissance')" type="date" required />
      <CtifFieldRow v-model="model.birth_city" :label="$gettext('Lieu de naissance')" required />
      <CtifFieldRow v-model="model.birth_country" :label="$gettext('Pays de naissance')" required />
      <CtifFieldRow v-model="model.national_register_number" :label="$gettext('N° de registre national')" />
      <CtifFieldRow v-model="model.occupation" :label="$gettext('Activité')" />
      <CtifFieldRow v-model="model.nationality" :label="$gettext('Nationalité')" required />
    </div>
    <h5 class="mt-2 text-xs font-semibold uppercase text-gray-500">{{ $gettext("Adresse") }}</h5>
    <div class="grid grid-cols-2 gap-3">
      <CtifFieldRow v-model="address.street" :label="$gettext('Rue')" :required="!addressOptional" />
      <CtifFieldRow v-model="address.number" :label="$gettext('Numéro')" />
      <CtifFieldRow v-model="address.zipcode" :label="$gettext('Code postal')" :required="!addressOptional" />
      <CtifFieldRow v-model="address.city" :label="$gettext('Localité')" :required="!addressOptional" />
      <CtifFieldRow v-model="address.country" :label="$gettext('Pays')" :required="!addressOptional" />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import CtifFieldRow from "@/components/ctif/CtifFieldRow.vue";

const props = defineProps({
  modelValue: { type: Object, required: true },
  title: { type: String, default: "Personne physique" },
  removable: { type: Boolean, default: false },
  addressOptional: { type: Boolean, default: false },
});
defineEmits(["remove"]);

const model = computed(() => props.modelValue);
const address = computed(() => props.modelValue.address);
</script>
